import {
  DeleteForever as DeleteForeverIcon,
  Edit as EditIcon,
} from '@mui/icons-material';
import { MenuItem } from '@mui/material';
import apiEndpoints from 'constants/endpoints';
import { DataGridActionMenu, DataGridListPage } from 'pages/Common';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { deleteDataGridRow } from 'store/actions';
import { pageKeys } from 'store/reducers/dataGrid.reducer';
import { getSportName } from 'utils';


export const EventTypeList = () => {
  const history = useHistory();
  const sportsById = useSelector(state=> state.sports.sportsById);
  const dispatch = useDispatch();

  const onDelete = useCallback((id) => {
    const confirmed = window.confirm("Are you sure you want to delete this equipment permanently?");
    if (confirmed) {
      dispatch(deleteDataGridRow(apiEndpoints.eventTypes, id, {}, {}, pageKeys.eventTypeList));
    }
  }, [dispatch]);

  const columns = useMemo(() => {

    return [
      {
        field: 'id',
        headerName: 'Id',
        width: 80,
      },
      {
        field: 'sportId',
        headerName: 'Sport',
        width: 120,
        valueFormatter: ({ value }) => getSportName(sportsById, value),
      },
      {
        field: 'name',
        headerName: 'Name',
        flex: 1,
      },
      {
        field: 'actions',
        headerName: 'Actions',
        cellStyle: {textAlign: 'center'},
        headerClass: 'text-center',
        cellRenderer: ({ data }) => (
          <>
            <DataGridActionMenu>
              <MenuItem onClick={() => history.push(`/${apiEndpoints.eventTypes}/${data.id}`)}><EditIcon />Edit</MenuItem>
              <MenuItem onClick={() => onDelete(data.id)}><DeleteForeverIcon/>Remove</MenuItem>
            </DataGridActionMenu>
          </>
        ),
      },
    ]
  }, [history, sportsById, onDelete]);

  return <DataGridListPage
    columns={columns}
    filters={[{
      field: 'searchStr',
      label: 'Search',
      type: 'search',
      value: null
    }]}
    heading="Event Types"
    apiEndpoint={apiEndpoints.eventTypes}
    initialQueryParams={{
      lang: 'en',
      limit: 20,
    }}
    onAdd={() => history.push(`/${apiEndpoints.eventTypes}/new`)}
    pageKey={pageKeys.eventTypeList}
  />
}

